// extracted by mini-css-extract-plugin
export var bounce = "mediaFullWidth-module--bounce--fe80f";
export var btnFacebook = "mediaFullWidth-module--btn-facebook--ef0fe";
export var btnLinkedin = "mediaFullWidth-module--btn-linkedin--ee812";
export var btnWechat = "mediaFullWidth-module--btn-wechat--0f53b";
export var btnWrap = "mediaFullWidth-module--btnWrap--12393";
export var btnXing = "mediaFullWidth-module--btn-xing--da1ae";
export var btnYoutube = "mediaFullWidth-module--btn-youtube--93c79";
export var cameraAccessoriesListingPager = "mediaFullWidth-module--cameraAccessoriesListingPager--c10a5";
export var container = "mediaFullWidth-module--container--75dcc";
export var fadeIn = "mediaFullWidth-module--fadeIn--21b21";
export var grid = "mediaFullWidth-module--grid--71428";
export var icon = "mediaFullWidth-module--icon--182f5";
export var iconText = "mediaFullWidth-module--icon-text--578f8";
export var image = "mediaFullWidth-module--image--6771c";
export var imageDescription = "mediaFullWidth-module--imageDescription--ef5f4";
export var mail = "mediaFullWidth-module--mail--57f3e";
export var mediaContainer = "mediaFullWidth-module--mediaContainer--fc394";
export var mobileTeasers = "mediaFullWidth-module--mobileTeasers--284bc";
export var nestedContentTeaser = "mediaFullWidth-module--nestedContentTeaser--e5352";
export var newsDetailWrap = "mediaFullWidth-module--newsDetailWrap--0be6f";
export var oneColumn = "mediaFullWidth-module--oneColumn--3ce0e";
export var phone = "mediaFullWidth-module--phone--3bdde";
export var printer = "mediaFullWidth-module--printer--de2f0";
export var reducedWidth = "mediaFullWidth-module--reducedWidth--7b5ff";
export var teaserBottomContent = "mediaFullWidth-module--teaserBottomContent--d9195";
export var textCap = "mediaFullWidth-module--textCap--ac063";
export var twoColumn = "mediaFullWidth-module--twoColumn--87199";
export var video = "mediaFullWidth-module--video--c72b0";